module.exports = __webpack_public_path__ + "static/media/M1-15-Espelhamento-Arcano-cod114.cb8b0ba6.png";